import React from 'react';
import { CpuIcon } from 'lucide-react';
export function SiteFooter() {
  return <footer className="w-full bg-forest-900 px-6 pb-24 pt-14" data-id="element-167" data-mp="3r89bt43culeb">
      <div className="mx-auto max-w-4xl text-center" data-id="element-168" data-mp="3r919qlkfcv7r">
        <p className="flex items-center justify-center gap-2 font-display text-xl font-semibold text-cream-50" data-id="element-169" data-mp="3mh172lcyzo7h">
          <CpuIcon className="h-5 w-5 text-ember-400" aria-hidden="true" data-id="element-170" data-mp="3hheri59o5vvi" />
          Kit Instrumentación Industrial
        </p>
        <p className="mt-4 text-base text-cream-100/70" data-id="element-171" data-mp="3di5xr0empxzy">
          Hecho por especialistas en Automatización, para docentes que exigen rigor técnico y libertad de
          tiempo.
        </p>
        <p className="mx-auto mt-8 max-w-2xl text-sm leading-relaxed text-cream-100/45" data-id="element-172" data-mp="33j6xa540p8o1">
          Kit Instrumentación Industrial es una herramienta digital de apoyo pedagógico para docentes. Los
          contenidos deben adaptarse a la normativa y a las prácticas de seguridad vigentes en cada país e
          institución; no reemplaza la formación profesional ni el criterio del docente responsable de cada
          materia.
        </p>
        <nav aria-label="Enlaces legales" className="mt-8 flex justify-center gap-6 text-sm" data-id="element-173" data-mp="1apyfkr0s51qc">
          <a href="#terminos" className="text-cream-100/70 underline-offset-4 transition-colors duration-150 ease-out hover:text-cream-50 hover:underline" data-id="element-174" data-mp="vsp90q2wnre1">
            Términos y Condiciones
          </a>
          <a href="#privacidad" className="text-cream-100/70 underline-offset-4 transition-colors duration-150 ease-out hover:text-cream-50 hover:underline" data-id="element-175" data-mp="1ohd237twbl25">
            Política de Privacidad
          </a>
        </nav>
        <p className="mt-8 border-t border-cream-100/10 pt-6 text-xs text-cream-100/40" data-id="element-176" data-mp="1esbk5c3sitlj">
          © 2026 Kit Instrumentación Industrial — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}